<template>
	<div>
		<el-button style="margin-bottom: 20px;" type="primary" @click="setsu('null')">添加轮播</el-button>
		<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" border stripe
			@selection-change="handleSelectionChange">
			<!-- <el-table-column label="名称" align="center" prop="name"></el-table-column> -->
			<el-table-column label="类型描述" align="center">
				<template slot-scope="scope">
					<div class="">
						{{ scope.row.type == 0 ? '跳转商品' : '跳转分类' }}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="图片" align="center">
				<template slot-scope="scope">
					<el-image style="height: 50px;" :src="scope.row.imgUrl" :preview-src-list="[scope.row.imgUrl]" />
				</template>
			</el-table-column>
			<el-table-column label="排序" align="center" prop="sort"></el-table-column>
			<el-table-column label="操作" align="center" prop="icon" fixed="right">
				<template slot-scope="scope">

					<el-button type="primary" plain @click="UpdateConfigTypeButton(scope.row)">编辑</el-button>
					<el-popconfirm title="确定删除该轮播吗？" @confirm="delHandle(scope.row.id)">
						<el-button type="danger" plain slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
	<!-- 	<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]" :current-page="current"
			:page-size="size" :total="total">
		</el-pagination> -->
		<el-dialog title="轮播" :visible.sync="dialogVisible" width="800px" append-to-body :before-close="handleClose">
			<el-form :model="editForm" ref="editForm" label-width="100px" class="demo-editForm">
				<!-- <el-form-item label-width="100px" label="跳转类型">
					<el-select v-model="type" clearable placeholder="选择类型">
						<el-option label="跳转商品" value="0"></el-option>
						<el-option label="跳转分类" value="1"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item label-width="100px" label="名称"> <el-input v-model="name"></el-input>
				</el-form-item>
				<el-form-item label-width="100px" label="排序"> <el-input v-model="sort" type="number"></el-input>
				</el-form-item>
				<!-- <el-form-item v-if="type == 0" label-width="100px" label="跳转商品"> {{ shoptit }} <el-button type="primary"
						@click="setshop('')">选择商品</el-button>
				</el-form-item>
				<el-form-item v-if="type == 1" label-width="100px" label="跳转商品">
					<el-cascader placeholder="选择分类" :options="typeList" v-model="cidlist"
						:props="{ value: 'id', label: 'name', children: 'children' }" ref="cateData" clearable
						filterable></el-cascader>

				</el-form-item> -->
				<el-form-item label-width="180px" label="轮播图(尺寸690*280)" prop="storeGoodsCover">
					<VploadImg :limit="1" v-bind:file-list="filesd" :type="1" @submitImg="getImg"></VploadImg>
				</el-form-item>
				<el-form-item> <el-button type="primary" @click="submitForm()">完成</el-button> </el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="选择商品" :visible.sync="shopVisible" width="80%" append-to-body :before-close="handlecrile">
			<div style="padding-bottom: 40px;">
				<el-form :inline="true">
					<el-form-item label="商品名" label-width="80px">
						<el-input v-model="shopForm.name" placeholder="商品名" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="品牌" label-width="100">
						<el-select v-model="shopForm.brandId" clearable filterable placeholder="选择品牌">
							<el-option v-for="(item, index) in supList" :key="index" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商品分类" label-width="80px">
						<el-cascader placeholder="选择分类" :options="typeList" v-model="classifyId"
							:props="{ checkStrictly: true, value: 'id', label: 'name', children: 'children' }"
							@change="onSelectPMenu" ref="cateData" clearable filterable></el-cascader>
					</el-form-item>
					<el-form-item>
						<el-button @click="getsch()" type="success">搜索</el-button>
					</el-form-item>
				</el-form>
				<el-table ref="multipleTable" :data="shopData" style="width:100%" border stripe>
					<el-table-column width="100" align="center" label="商品封面" prop="storeGoodsCover">
						<template slot-scope="scope">
							<el-image style="width: 70px; height: 70px" :src="scope.row.cover"
								fit="scale-down"></el-image>
						</template>
					</el-table-column>
					<el-table-column align="center" label="商品名称" prop="name"></el-table-column>
					<el-table-column width="148" align="center" label="商品类型" prop="firstClassifyName">
						<template slot-scope="scope">
							{{ scope.row.firstClassifyName }}-{{ scope.row.classifyName }}
						</template>
					</el-table-column>
					<el-table-column width="150" align="center" label="商品价格" prop="price"></el-table-column>
					<el-table-column align="center" label="商品品牌" prop="brandName"></el-table-column>
					<el-table-column width="300" align="center" label="操作" prop="icon" fixed="right">
						<template slot-scope="scope">
							<el-button type="primary" plain
								@click="chooseshop(scope.row)">{{ storeGoodsId == scope.row.id ? '已选择' : '选择' }}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="shopSizeChange" @current-change="shopCurrentChange"
					layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]"
					:current-page="currentd" :page-size="sized" :total="totald">
				</el-pagination>
			</div>

		</el-dialog>
	</div>
</template>
<script>
import VploadImg from "../inc/VploadImgThree";
export default {
	name: "ConfigType",
	components: {
		VploadImg
	},
	data() {
		return {
			searchForm: {

			},
			shopForm: {
				pageNo: 1,
				pageSize: 10,
				storeGoodsType: "",
				supplierName: "",
				classifyFirstId: '',
				name: '',
				type: 0
			},
			delBtlStatu: true,
			tableData: [],
			tablecrile: [],
			shopData: [],
			multipleSelection: [],
			filesd: [],
			editForm: {},
			total: 0,
			size: 10,
			current: 1,
			totald: 0,
			sized: 10,
			currentd: 1,
			sizes: 10,
			currents: 1,
			totals: 0,
			dialogVisible: false,
			crileVisible: false,
			shopVisible: false,
			articleId: '',
			image: "",
			jumpPath: "",
			jumpType: '1',
			//----------
			name: "",
			sort: 0,
			storeGoodsId: '',
			type: '0',
			id: '',
			inforlist: [],
			typeList: [],
			supList: [],
			articleClassId: '',
			title: '',
			criletit: '',
			shoptit: '',
			classifyId: '',
			classifyFirstId: '',
			cidlist: []
		}
	},
	created() {
		this.getConfigType();
		this.getTypeList()
		this.supp()

	},
	methods: {
		onSelectPMenu() {

		},
		supp() {
			this.$axios.get("/admin/brand/getBrandListNoPage").then(res => {
				this.supList = res.data;
			})
		},
		getTypeList() {
			this.$axios.get("/admin/commodityClassify/getAllLevelList").then(res => {
				this.typeList = res.data;
			})
		},
		getTypeButton(e) {

			this.$axios.post("/admin/carousel/modifyState", {
				id: e.id
			}).then(res => {
				this.getConfigType()
				this.$message({
					showClose: true,
					message: '恭喜你，操作成功',
					type: 'success',
					onClose: () => {

					}
				});
			})
		},
		delHandle(id) {
			this.$axios.post("/admin/homeCarouse/deleteHomeCarouse", {
				id: id
			}).then(res => {
				this.getConfigType()
				this.$message({
					showClose: true,
					message: '恭喜你，操作成功',
					type: 'success',
					onClose: () => {

					}
				});
			})
		},
		chooseshop(e) {
			if (this.storeGoodsId == e.id) {
				this.storeGoodsId = ''
				this.shoptit = ''
			} else {
				this.storeGoodsId = e.id
				this.shoptit = e.name
			}
			this.shopVisible = false
		},

		choose(e) {
			if (this.articleId == e.id) {
				this.articleId = ''
				this.criletit = ''
				this.jumpPath = ""
			} else {
				this.jumpPath = "/pages/caildetail/index?id=" + e.id
				this.articleId = e.id
				this.criletit = e.title
			}
			this.crileVisible = false
		},


		getmass() {
			this.currents = 1
			this.getInformations()
		},
		setcrile() {
			this.crileVisible = true
			this.getInformations()
		},
		//添加轮播
		setsu() {
			this.id = ''
			this.imgUrl = ''
			this.name = ''
			this.classifyFirstId = ''
			this.sort = 0
			this.storeGoodsId = ''
			this.filesd = []
			this.shoptit = ''
			this.dialogVisible = true
			this.cidlist = []
		},
		getImg(url, add) {

			if (add == 1) {
				this.imgUrl = url
			} else if (add == 0) {
				this.imgUrl = ''
			}

		},
		setshop() {
			this.shopVisible = true
			this.getStoreGoods()
		},
		handleClose() {
			this.dialogVisible = false
		},
		handlecrile() {
			this.crileVisible = false
			this.shopVisible = false
		},
		getsch() {
			this.currentd = 1
			this.getStoreGoods()
		},
		getStoreGoods() {
			// if (this.classifyId.length > 0) {
			// 	this.typeList.map(item => {
			// 		item.children.map(itrs => {
			// 			if (this.classifyId[1] == itrs.id) {
			// 				this.shopForm.classifyId = itrs.uid
			// 			}
			// 		})
			// 	})
			// } else {
			// 	this.searchForm.classifyId = ''
			// }
			if (this.classifyId.length > 0) {
				this.shopForm.classifyFirstId = this.classifyId[0]
				if (this.classifyId.length > 1) {
					this.typeList.map(item => {
						item.children.map(itrs => {
							if (this.classifyId[1] == itrs.id) {
								this.shopForm.classifyId = itrs.uid
							}
						})
					})
				} else {
					this.shopForm.classifyId = ''
				}
			} else {
				this.shopForm.classifyId = ''
				this.shopForm.classifyFirstId = ''
			}
			this.shopForm.pageNo = this.currentd
			this.shopForm.pageSize = this.sized
			this.shopForm.type = 0

			this.$axios.post("/admin/commodity/getUpperCommodityList", this.shopForm).then(res => {
				this.shopData = res.data.records
				this.sized = res.data.size
				this.currentd = res.data.current
				this.totald = res.data.total
			})
		},
		getInformations() {
			var startTime = '';
			var endTime = '';
			if (this.searchForm.created != undefined) {
				startTime = this.searchForm.created[0];
				endTime = this.searchForm.created[1];
			}
			this.searchForm.startTime = startTime
			this.searchForm.endTime = endTime;

			this.$axios.get("/admin/article/getArticleList", {
				params: {
					pageNo: this.currents,
					pageSize: this.sizes,
					articleClassId: this.articleClassId,
					startTime: startTime,
					endTime: endTime,
					title: this.title,
					state: 1,
				}
			}).then(res => {
				this.tablecrile = res.data.records
				this.sizes = res.data.size
				this.currents = res.data.current
				this.totals = res.data.total
			})
		},
		submitForm() {
			if (this.imgUrl) {

			} else {
				this.$message({
					showClose: true,
					message: '请上传图片',
					type: 'info',
					onClose: () => {

					},
				})
				return
			}
			var fyid = ''
			if (this.cidlist.length > 0) {
				this.typeList.map(item => {
					item.children.map(itrs => {
						if (this.cidlist[1] == itrs.id) {
							fyid = itrs.uid
						}
					})
				})
			} else {
				fyid = ''
			}

			if (this.id) {
				this.$axios.post("/admin/homeCarouse/updateHomeCarouse", {
					id: this.id,
					imgUrl: this.imgUrl,
					name: this.name,
					sort: this.sort,
					tcommodityId: this.storeGoodsId,
					state: 1,
					type: this.type,
					classifyId: fyid,
					firstClassifyId: this.cidlist.length > 0 ? this.cidlist[0] : ''
				}).then(res => {
					this.dialogVisible = false
					this.getConfigType()
					this.$message({
						showClose: true,
						message: '恭喜你，操作成功',
						type: 'success',
						onClose: () => {

						},
					})
				})
			} else {
				this.$axios.post("/admin/homeCarouse/addHomeCarouse", {
					imgUrl: this.imgUrl,
					name: this.name,
					sort: this.sort,
					tcommodityId: this.storeGoodsId,
					state: 1,
					type: this.type,
					classifyId: fyid,
					firstClassifyId: this.cidlist.length > 0 ? this.cidlist[0] : ''

				}).then(res => {
					this.dialogVisible = false
					this.getConfigType()
					this.$message({
						showClose: true,
						message: '恭喜你，操作成功',
						type: 'success',
						onClose: () => {

						},
					})
				})
			}

		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
			this.delBtlStatu = val.length == 0
		},

		handleSizeChange(val) {
			this.size = val
			this.getConfigType()
		},
		handleCurrentChange(val) {
			this.current = val
			this.getConfigType()
		},
		crileCurrentChange() {
			this.currents = val
			this.getInformations()
		},
		crileChange(val) {
			this.currents = val
			this.getInformations()
		},
		shopSizeChange(val) {
			this.currentd = val
			this.getStoreGoods()
		},
		shopCurrentChange(val) {
			this.currentd = val
			this.getStoreGoods()
		},
		//获取常量数据配置列表
		getConfigType() {

			this.$axios.post("/admin/homeCarouse/getHomeCarouseList", this.searchForm).then(res => {
				this.tableData = res.data

			})
		},
		//编辑
		UpdateConfigTypeButton(id) {
			if (id.classifyId) {
				var acc = []
				acc.push(id.firstClassifyId)
				acc.push(id.classifyId)
				this.cidlist = acc
			}
			this.id = id.id
			this.imgUrl = id.imgUrl
			this.name = id.name
			this.sort = id.sort
			this.filesd = []
			var fles = {
				url: id.imgUrl
			}

			if (id.type == 0) {
				this.storeGoodsId = id.tcommodityId
				this.shoptit = id.tcommodityName
			}

			this.filesd.push(fles)
			this.dialogVisible = true
		},
	}
}
</script>

<style scoped>
.el-button {
	padding: 0 10px;
	height: 35px;
	line-height: 35px;
	font-size: 15px;
	margin-right: 10px;
}
</style>